import { CollectionHelper } from 'src/app/helpers/collection-helper';
import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import { IP_BOARD_PART_TYPE_CHOICES } from 'src/app/model/product/ip-board/ip-board-part-type';
import { SignWithStockAmount } from './sign-with-stock-amount';

export class ClientSignSelectorHelper {
  private constructor() {}

  public static readonly CUSTOM_SIGN_OPTION_ID = -1;
  public static readonly RECOMMENDED_COLLABORATIVE_SIGN_OPTION_ID = -2;
  public static readonly ALTERNATIVE_COLLABORATIVE_SIGN_OPTION_ID = -3;

  static setDisplayExampleStyle(o: SignWithStockAmount) {
    const displayExample = CollectionHelper.isPopulated(o.examples)
      ? o.examples.find(e => e != null && !e.archived)
      : null;
    if (displayExample != null) {
      o.displayExampleStyle = this.getBackgroundImageStyle(
        `/api/assets/${displayExample.asset.uuid}`
      );
    }
  }

  static setAmountStockClass(o: SignWithStockAmount) {
    o.amountStockClass =
      o.totalStock == null ||
      o.totalStock === 0 ||
      (o.minimumStock != null && o.totalStock < o.minimumStock)
        ? 'red-stock-amount'
        : 'green-stock-amount';
  }

  static getBackgroundImageStyle(url: string): any {
    return {
      'background-image': `url('${url}')`,
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      'background-size': 'contain'
    };
  }

  static getSelectedSignOptionId(
    ipBoardPart: IPBoardPart,
    collaborative: boolean
  ): number {
    if (ipBoardPart.sign != null) {
      return null;
    } else if (!collaborative) {
      return this.CUSTOM_SIGN_OPTION_ID;
    } else {
      return (ipBoardPart.otherIPBoardPartType != null &&
        ipBoardPart.otherIPBoardPartType.ordinal ===
          IP_BOARD_PART_TYPE_CHOICES.IP_100_140.ordinal &&
        (ipBoardPart.otherWidth === 100 && ipBoardPart.otherHeight === 140)) ||
        (ipBoardPart.otherWidth === 140 && ipBoardPart.otherHeight === 100)
        ? this.RECOMMENDED_COLLABORATIVE_SIGN_OPTION_ID
        : this.ALTERNATIVE_COLLABORATIVE_SIGN_OPTION_ID;
    }
  }
}
